import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'localizedDate',
  pure: false,
  standalone: true,
})
export class LocalizedDatePipe implements PipeTransform {
  constructor(
    private translateService: TranslateService,
    private datePipe: DatePipe
  ) {}

  transform(
    value: any,
    pattern: string = 'd MMMM yyyy',
  ): any {
    if (value && !isNaN(Date.parse(value))) {
      return this.datePipe.transform(
        new Date(value),
        pattern,
        '',
        this.translateService.defaultLang
      );
    }
    return null;
  }
}
